var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full m-0 p-0",attrs:{"id":"app"}},[_c('NavbarComponent'),_c('router-view',{attrs:{"data":_vm.datas}}),_c('FooterComponent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }